/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  List,
  Popconfirm,
  Row,

} from "antd";

import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";

const NewTemplateItemCards = (props) => {
  const { data, deleteItem, onAdd,deleteItemfromList } = props;
  const [listItems, setListItems] = useState([]);
  const [itemName, setItemName] = useState([]);

  function handleAddCards() {
    const newList = listItems.concat({ id: uuidv4() });
    setListItems(newList);
  }

  function handleRemoveAccount(id) {
    deleteItem(id);
    setListItems([]);
  }
  function handleRemoveItemfromList(id) {
    deleteItemfromList(id)
  }

  const [form] = Form.useForm();

  const onFinish = (values) => {
    console.log("Form submitted!", values);

    onAdd(itemName, data.key);
    setListItems([]);
  };

  function handleBlur() {
    form.submit();
  }

  const handleInput = (e) => {
    setItemName({
      key: e.target.value,
      itemTitle: e.target.value,
    });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const validateInput = (_, value) => {
    if (!value) {
      return Promise.reject("can't be blank");
    }
    return Promise.resolve();
  };


  return (
    <div>
      <Card
        title={data.itemCardTitle}
        id={data.itemCardTitle}
        extra={
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleRemoveAccount(data.key)}
          >
            <a style={{ color: "red" }}>Delete Area</a>
          </Popconfirm>
        }
      >
        <List
          className="demo-loadmore-list"
          itemLayout="horizontal"
          dataSource={data.items}
          renderItem={(item) => (
            <Card size="small" id={item.key}>
              <List.Item
                actions={[
                  <Popconfirm
                  title="Sure to delete?"
                  onConfirm={() => handleRemoveItemfromList(item.key)}
                >
                  <a key="list-item-delete" style={{ color: "red" }}>
                    Delete Item
                  </a>
                  </Popconfirm>
                ]}
              >
                <List.Item.Meta title={<span>{item.itemTitle}</span>} />
              </List.Item>
            </Card>
          )}
        />
        {listItems.map((item, index) => (
          <Card key={item.key}>
            <Form
              name="basic"
              labelCol={{
                span: 8,
              }}
              initialValues={{
                remember: true,
              }}
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              layout="vertical"
            >
              <Row justify="space-between">
                <Col span={18}>
                  <Form.Item
                    name={`cardItemTitle${index}`}
                    rules={[{ validator: validateInput }]}
                    required
                  >
                    <Input
                      autoFocus
                      onBlur={handleBlur}
                      onChange={handleInput}
                      style={{ width: "30%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={3}>
                  <Row justify="space-between">
                    <Col>
                    <Popconfirm
                      title="Sure to delete?"
                      onConfirm={() => handleRemoveAccount(item.id)}
                    >
                      <a style={{ color: "red" }}>Delete Item</a>
                    </Popconfirm>
                    </Col>
                  </Row>
                </Col>
              </Row>
              
            </Form>
          </Card>
        ))}
        <Button type="link" style={{ width: "100%" }} onClick={handleAddCards}>
          <i className="fa-solid fa-plus" style={{ marginRight: "5px" }}></i>{" "}
          Add Item
        </Button>
      </Card>
      <br />
    </div>
  );
};

export default NewTemplateItemCards;
